"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ModuleItemFilter = (0, vue_1.resolveComponent)("ModuleItemFilter");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ModuleItemFilter, {
        title: "Preludes",
        groups: _ctx.GROUPS,
        itemsByGroup: _ctx.ALL_CARDS_BY_MODULE,
        selected: _ctx.initialSelected,
        "onUpdate:selected": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('prelude-list-changed', $event))),
        onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
    }, {
        item: (0, vue_1.withCtx)(({ itemName, icon }) => [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(itemName), 1)
            ])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.compatibility(itemName), (m) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: m,
                    class: (0, vue_1.normalizeClass)(icon(m))
                }, null, 2));
            }), 128))
        ]),
        _: 1
    }, 8, ["groups", "itemsByGroup", "selected"]));
}
